const STATE = {
  recursive: false,
  orgapanels: [],
  orgafilter: []
}

export default STATE
